export const PrivacyPolicy = () => <div>Privacy Policy</div>;
